import { HttpSuccessDto } from "@common/dto/http";
import { ProfileGetDto } from "@common/dto/profile/get-dto";
import client, { clientTransformed } from "@common/utils/rest";

const URL_PREFIX = 'apis/userMaintenance';

export const getProfile = (userName: string): Promise<ProfileGetDto> => {
  return client({
    path: `${URL_PREFIX}/userprofile/${userName}`,
    method: 'GET',
  }).then((response: HttpSuccessDto<{ payLoad: ProfileGetDto }>) => {
    return response.entity.payLoad;
  });
};

export const getUsername = (): Promise<string> => {
  return clientTransformed({
    path: 'api/userMaintenance/username',
    method: 'GET',
  }).then((response: HttpSuccessDto<string>) => {
    return response.entity;
  });
};